import { Link } from "react-router-dom";
import { InstagramLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { Snake, Vine } from "@/components/decor/SvgIcons";

export default function Footer() {
  return (
    <footer className="relative mt-24 overflow-hidden bg-forest text-cream" data-testid="site-footer">
      <div className="absolute inset-x-0 -top-1 opacity-70">
        <Vine className="w-full h-16 rotate-180" />
      </div>

      {/* Peeking snake */}
      <div className="absolute -top-4 right-8 md:right-24 opacity-90" aria-hidden="true">
        <Snake size={110} className="rotate-12" />
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-10 pt-24 pb-10 relative">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-5">
              <img
                src="/brand/spooky-scales-logo.jpg"
                alt="Spooky Scales"
                className="w-28 h-28 md:w-32 md:h-32 rounded-2xl object-cover border border-cream/30 shadow-lg"
              />
              <div>
                <div className="font-display text-3xl md:text-4xl">Spooky Scales</div>
                <div className="font-script text-lavender text-xl -mt-1">Southern California</div>
              </div>
            </div>
            <p className="mt-5 max-w-md text-cream/80 leading-relaxed">
              Reptiles &amp; amphibians brought to schools, libraries, festivals, and homes with
              curiosity, care, and a little bit of magic.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="https://instagram.com/spookyscalessocal" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="p-3 rounded-full bg-cream/10 hover:bg-cream/20 transition">
                <InstagramLogo size={20} />
              </a>
              <a href="mailto:spookyscalessocal@gmail.com" data-testid="footer-email" className="p-3 rounded-full bg-cream/10 hover:bg-cream/20 transition">
                <EnvelopeSimple size={20} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs tracking-[0.2em] uppercase text-lavender mb-4">Wander</div>
            <ul className="space-y-2 text-cream/90">
              <li><Link to="/" className="link-underline">Home</Link></li>
              <li><Link to="/booking" className="link-underline">Presentations &amp; Booking</Link></li>
              <li><Link to="/animals" className="link-underline">Meet Our Animals</Link></li>
              <li><Link to="/adoptables" className="link-underline">Adoptables</Link></li>
              <li><Link to="/resources" className="link-underline">Husbandry Resources</Link></li>
              <li><Link to="/contact" className="link-underline">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs tracking-[0.2em] uppercase text-lavender mb-4">Cottage Hours</div>
            <ul className="space-y-1 text-cream/90">
              <li>Available Sun &amp; Mon</li>
              <li>Other days by request</li>
            </ul>
            <div className="mt-4 text-sm text-cream/70">
              Service area: Ventura &amp; Los Angeles County — virtual worldwide.
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-cream/15 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/70">
          <div>© {new Date().getFullYear()} Spooky Scales · Made with moss &amp; moonlight.</div>
          <div className="font-script text-lg text-lavender">Where curiosity meets conservation.</div>
        </div>
      </div>
    </footer>
  );
}
